export default __webpack_public_path__ + "static/2318-1c813245aaaabf0fc25f2faad429089f.gif";